export const levelColor = {
  INFO: '#468ae6',
  WARNING: '#e69436',
  ERROR: '#b4433a',
  SUCCESS: '#49a350',
};
